import { CSSProperties, ReactNode } from 'react';
import { useReduxState } from 'hooks';

interface Props {
  category?: string;
  label?: string;
  style?: CSSProperties;
  tooltip?: string;
  value: ReactNode;
  unreadItems?: number;
}

const TaskSummaryItem = ({
  category = 'default',
  label,
  style,
  tooltip,
  value,
  unreadItems
}: Props) => {
  const { theme } = useReduxState();

  const styles = {
    default: {
      labelColor: theme.textColorLighter,
      valueBackgroundColor: theme.lightGreyDark,
      valueColor: theme.textColorLight
    },
    danger: {
      labelColor: theme.dangerColor,
      valueBackgroundColor: theme.dangerColor,
      valueColor: theme.dangerTextColor
    }
  }[category];

  return (
    <div
      className="item"
      style={style}
      {...(tooltip
        ? {
            'aria-label': tooltip,
            'data-tooltip': tooltip
          }
        : {})}
    >
      <div className="value">{value}</div>
      {label ? <div className="label">{label}</div> : null}
      {unreadItems ? <div className="unread">{unreadItems}</div> : null}

      <style jsx>{`
        .item {
          display: inline-block;
          margin-right: 20px;
          position: relative;
        }
        .value {
          background-color: ${styles.valueBackgroundColor};
          border-radius: 20px;
          color: ${styles.valueColor};
          display: inline-block;
          font-size: 1.4rem;
          font-weight: 600;
          margin-right: ${label ? '5px' : '0px'};
          padding: 2px 8px 3px;
        }
        .label {
          color: ${styles.labelColor};
          display: inline-block;
          font-size: 1.4rem;
          font-weight: 600;
        }
        .unread {
          background-color: ${theme.dangerColor};
          border-radius: 10px;
          color: ${theme.dangerTextColor};
          display: inline-block;
          font-size: 1rem;
          font-weight: 700;
          line-height: 1;
          padding: 3px 6px;
          position: absolute;
          right: -10px;
          top: -6px;
        }
      `}</style>
    </div>
  );
};

export default TaskSummaryItem;
